<template>
  <nav class="app-bnav">
    <!-- Authenticated user tabs -->
    <template v-if="auth">
      <button class="bnav-tab" :class="{ active: isHome }" @click="nav('/')">
        <span class="bnav-icon-wrap"><i class="pi pi-home"></i></span>
        <span class="bnav-label">الرئيسية</span>
      </button>
      <button class="bnav-tab" :class="{ active: isContents }" @click="nav('/contents')">
        <span class="bnav-icon-wrap"><i class="pi pi-book"></i></span>
        <span class="bnav-label">الحصص</span>
      </button>
      <button class="bnav-tab" :class="{ active: isExams }" @click="nav('/exams?type=online')">
        <span class="bnav-icon-wrap"><i class="pi pi-file-edit"></i></span>
        <span class="bnav-label">امتحانات</span>
      </button>
      <button class="bnav-tab" :class="{ active: isHomework }" @click="nav('/exams?type=homework')">
        <span class="bnav-icon-wrap"><i class="pi pi-briefcase"></i></span>
        <span class="bnav-label">الواجبات</span>
      </button>
      <button class="bnav-tab" :class="{ active: isProfile }" @click="nav('/update_data')">
        <span class="bnav-icon-wrap"><i class="pi pi-user"></i></span>
        <span class="bnav-label">حسابي</span>
      </button>
    </template>

    <!-- Guest tabs -->
    <template v-else>
      <button class="bnav-tab" :class="{ active: isHome }" @click="nav('/')">
        <span class="bnav-icon-wrap"><i class="pi pi-home"></i></span>
        <span class="bnav-label">الرئيسية</span>
      </button>
      <button class="bnav-tab" :class="{ active: isSearch }" @click="nav('/search')">
        <span class="bnav-icon-wrap"><i class="pi pi-search"></i></span>
        <span class="bnav-label">بحث</span>
      </button>
      <button class="bnav-tab" :class="{ active: isLogin }" @click="nav('/login')">
        <span class="bnav-icon-wrap"><i class="pi pi-sign-in"></i></span>
        <span class="bnav-label">دخول</span>
      </button>
    </template>
  </nav>
</template>

<script>
export default {
  name: 'BottomNav',
  computed: {
    auth()       { return this.$store.getters['isAuthenticated']; },
    isHome()     { return this.$route.path === '/'; },
    isContents() { return this.$route.path === '/contents'; },
    isExams()    {
      return this.$route.path === '/exams' && this.$route.query.type !== 'homework';
    },
    isHomework() {
      return this.$route.path === '/exams' && this.$route.query.type === 'homework';
    },
    isProfile()  {
      const p = this.$route.path;
      return p === '/update_data' || p === '/update_password' ||
             p === '/whatsapp_link' || p === '/my_exams' || p.startsWith('/my_exam');
    },
    isSearch()   { return this.$route.path === '/search'; },
    isLogin()    { return this.$route.path === '/login'; },
  },
  methods: {
    nav(path) {
      if (this.$route.fullPath !== path) this.$router.push(path);
    },
  },
};
</script>

<style scoped>
/* Hidden on desktop; shown on mobile via media query */
.app-bnav {
  display: none;
}

@media (max-width: 768px) {
  .app-bnav {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1050;
    background: rgba(15, 15, 15, 0.97);
    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);
    border-top: 1px solid rgba(212, 175, 55, 0.2);
    border-radius: 20px 20px 0 0;
    box-shadow: 0 -4px 30px rgba(0, 0, 0, 0.5), 0 -1px 0 rgba(212, 175, 55, 0.12);
    padding: 5px 6px max(6px, env(safe-area-inset-bottom));
    justify-content: space-around;
    align-items: center;
    min-height: 62px;
    direction: rtl;
  }

  /* ─── Individual tab ─── */
  .bnav-tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    padding: 5px 8px;
    color: rgba(240, 237, 228, 0.4);
    background: transparent;
    border: none;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    position: relative;
    min-width: 48px;
    transition: color 0.18s ease;
    font-family: 'Cairo', 'Almarai', sans-serif;
  }

  .bnav-tab:active {
    transform: scale(0.87);
    transition: transform 0.1s ease;
  }

  .bnav-tab.active {
    color: #D4AF37;
  }

  /* Top accent bar for active tab */
  .bnav-tab.active::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 24px;
    height: 3px;
    background: linear-gradient(90deg, #D4AF37, #C89B2D);
    border-radius: 0 0 4px 4px;
    animation: tabIndicator 0.2s ease forwards;
  }

  @keyframes tabIndicator {
    from { width: 0; opacity: 0; }
    to   { width: 24px; opacity: 1; }
  }

  /* ─── Icon container ─── */
  .bnav-icon-wrap {
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    transition: background 0.18s ease, transform 0.18s ease;
  }

  .bnav-tab.active .bnav-icon-wrap {
    background: rgba(212, 175, 55, 0.1);
    transform: translateY(-2px) scale(1.1);
  }

  .bnav-icon-wrap i {
    font-size: 1.1rem;
    transition: font-size 0.18s ease;
  }

  .bnav-tab.active .bnav-icon-wrap i {
    font-size: 1.2rem;
  }

  /* ─── Label ─── */
  .bnav-label {
    font-size: 0.6rem;
    font-weight: 600;
    white-space: nowrap;
    line-height: 1;
    transition: font-weight 0.18s ease;
  }

  .bnav-tab.active .bnav-label {
    font-weight: 700;
  }
}
</style>
